import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './SignalTranslationList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialSignalTranslationState } from '../../reducers/initialState';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE } from '../../constants';
import SignalTranslationListTable from '../SignalTranslationList/SignalTranslationListTable';
import { WidgetVisibility } from '../../utils/widgetManager';
import ContentTemplate from '../ContentTemplate/ContentTemplate';

const SignalTranslationList = ({
  unitManager,
  getSignalTranslation,
  setCurrentPage,
  signalTranslationManager = {...initialSignalTranslationState.signalTranslation},
  intl,
  userProfileWidgets,
  currentTimezone
}) => {
  let filter = signalTranslationManager.filter || '';
  let offset = signalTranslationManager.offset || 0;
  let limit = signalTranslationManager.limit || 1000;

  let { unitSerialNumber } = useParams();

  useEffect(() => {
    let filterObj = {
      filter: filter,
      offset: offset,
      limit: limit
    };
    getSignalTranslation(unitSerialNumber, filterObj);
  }, [getSignalTranslation, offset, limit, filter]);

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const unitId = (unitManager.selectedUnit && unitManager.selectedUnit.UnitId) || 0;

  const signalTranslationObj = Object.values(signalTranslationManager.SignalTranslationList);

  let messageId = (signalTranslationManager && signalTranslationManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  return (
    <div className={s.signalTranslation}>
      {signalTranslationManager.isLoading && <LoadingSpinner />}
      <Banner
        failureText={messageText}
        showBanner={signalTranslationManager.showBanner}
        status={signalTranslationManager.isOpSuccessful}
        successText={messageText}
      />
      <ContentTemplate
        selectedPage="signalTranslation"
        userProfileWidgets={userProfileWidgets}
        widgetCode={'UNIT_SIGNALTRANSLATION'}
        tagoutRequired={false}
      >
        <div className={s.contentWrapper}>
          <Row>
            <Col sm={6} lg={8}>
              <div className={s.signalTranslationHeader}>
                <div className={s.subHeading}>
                  <FormattedMessage id="signalTranslation.signalTranslations" defaultMessage="SignalTranslations" />
                  <span data-unittest="signalTranslationDataCount" className={s.circle}>
                    {signalTranslationManager.SignalTranslationList.length}
                  </span>
                </div>
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <Link to={`/unit/signal-translations/${unitSerialNumber}/add/${unitId}/`}>
                <Button className={s.addbutton} style={WidgetVisibility(userProfileWidgets, `SIGNALTRANSLATION_ADD`)}>
                  + <FormattedMessage id="signalTranslation.addNew" defaultMessage="+ ADD NEW" />
                </Button>
              </Link>
            </Col>
          </Row>

          <div className="">
            <Pagination
              data={signalTranslationObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={signalTranslationManager.currentPage}
            >
              <SignalTranslationListTable
                userProfileWidgets={userProfileWidgets}
                currentTimezone={currentTimezone}
                unitId={unitId}
                unitSerialNumber={unitSerialNumber}
              />
            </Pagination>
          </div>
        </div>
      </ContentTemplate>
    </div>
  );
};

SignalTranslationList.propTypes = {
  getSignalTranslation: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  setPageFilter: PropTypes.func.isRequired,
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(SignalTranslationList);
